module.exports = __webpack_public_path__ + "static/media/load-more.ca23fc98.svg";